import { useEffect, useRef, useState } from "react";
import { TextNodeType } from "../../CommonLandingMweb.types";
import { Carousel, Container, Item, ItemInner, LeftIcon, Title } from "./Styles";
import FormattedText from "../../../FormattedText/FormattedText";

interface CarouselItem {
  title?: TextNodeType;
  subtitle?: TextNodeType;
  leftIcon?: string;
  rightIcon?: string;
  cta?: { title?: TextNodeType };
}

interface CarouselPersuasionProps {
  carouselData?: CarouselItem[];
}

export const CarouselPersuasion = ({ carouselData = [] }: CarouselPersuasionProps) => {
  const wrapRef = useRef<HTMLDivElement>(null);
  const [itemWidth, setItemWidth] = useState(0);

  useEffect(() => {
    const el = wrapRef.current;
    if (!el) return;
    const ro = new ResizeObserver(() => {
      setItemWidth(el.clientWidth);
    });
    ro.observe(el);
    setItemWidth(el.clientWidth);
    return () => ro.disconnect();
  }, []);

  if (!carouselData.length) return null;

  return (
    <Container ref={wrapRef}>
      <Carousel
        style={
          itemWidth
            ? {
                scrollSnapType: "x mandatory",
              }
            : undefined
        }
      >
        {carouselData.map((item, idx) => (
          <Item
            key={`cp-${idx}`}
            style={
              itemWidth
                ? {
                    minWidth: itemWidth,
                    maxWidth: itemWidth,
                    scrollSnapAlign: "start",
                  }
                : undefined
            }
          >
            <ItemInner>
              {item.leftIcon ? <LeftIcon src={item.leftIcon} alt="" /> : null}
              <Title>
                <FormattedText value={item.title} />
              </Title>
            </ItemInner>
          </Item>
        ))}
      </Carousel>
    </Container>
  );
};
